import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=45112a1c&scoped=true"
import script from "./Server.vue?vue&type=script&lang=js"
export * from "./Server.vue?vue&type=script&lang=js"
import style0 from "./Server.vue?vue&type=style&index=0&id=45112a1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45112a1c",
  null
  
)

export default component.exports